// custom scripts

function favProduct() {
  
  if (this.classList.contains("favorited")) {
    triggerToast("Von deiner <u>Wunschliste</u> entfernt.", this.getAttribute("data-imageUrl"));
    this.classList.remove("favorited");
    removeValueFromCookie(this.getAttribute("data-productId"));
    removeWishlistItem(this.getAttribute("data-productId"));
  } else {
    if (getCookieValue('favoritedProducts') == null || getCookieValue('favoritedProducts') == '') {
    	document.getElementById('added-to-wishlist-mail').classList.add("slide-right");
    } else {
    	triggerToast("Zu deiner <u>Wunschliste</u> hinzugefügt.", this.getAttribute("data-imageUrl"));
    }
    this.classList.add("favorited");
    addValueToCookie(this.getAttribute("data-productId"));
    addWishlistItem(
      this.getAttribute("data-productId"),
      this.getAttribute("data-productTitle"),
      this.getAttribute("data-productUrl"),
      this.getAttribute("data-imageUrl")
    );
  }
  
  document.getElementById('fav-count').innerHTML = countProducts();
}

  document.addEventListener('DOMContentLoaded', function() {
   
    const boxes = document.querySelectorAll('.favProduct');
    boxes.forEach(box => {
      box.addEventListener('click', favProduct);
    });
   
    document.getElementById('fav-count').innerHTML = countProducts();
  });
  
  function triggerToast(toast_text, imageurl) {
    
    var toast = document.querySelector('.toast-desktop-wrapper');
    if (toast != null) {
      toast.classList.add("toast-desktop-wrapper--shown");
    }
    setTimeout(function() {
      toast.classList.remove("toast-desktop-wrapper--shown");
    }, 3000)
  
    var toast_image = document.querySelector('.toast-desktop__image');
    var toast_text_div = document.querySelector('.toast-desktop__info div');
    if (toast != null) {
      toast.classList.add("toast-desktop-wrapper--shown");
    }
    toast_image.src = imageurl;
    toast_text_div.innerHTML = toast_text;
  
 
  }
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".toast-desktop-wrapper__close-btn").addEventListener("click", function () {
        document.querySelector(".toast-desktop-wrapper").classList.remove("toast-desktop-wrapper--shown");
    });
});

  function addValueToCookie(value) {
    myArray = getCookieValue('favoritedProducts').split(",");
    var index = myArray.indexOf(value);
    if (index !== -1) {
      myArray.splice(index, 1);
    }
    myArray.push(value);
  
    const cookieName = "favoritedProducts";
    const cookieValue = myArray.join(',');
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=boandbirdie.com';
  }
  
  function removeValueFromCookie(value) {
    myArray = getCookieValue('favoritedProducts').split(",");
    var index = myArray.indexOf(value);
    if (index !== -1) {
      myArray.splice(index, 1);
    }
  
    const cookieName = "favoritedProducts";
    const cookieValue = myArray.join(',');
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=boandbirdie.com';
  }
  
  const getCookieValue = (name) => (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  )
  
  // function initializeFavoritedProducts() {
  //   if (getCookieValue('favoritedProducts') == null) {
  //     return;
  //   }
  //   myArray = getCookieValue('favoritedProducts').split(",");
  //   myArray.forEach((favedProduct, index) => {
  //     if (favedProduct != "") {
       
  //       var favelements = document.querySelectorAll(`span[data-productid="${favedProduct}"]`);
  //       favelements.forEach(favelement => {
  //         if (favelement != null) {
  //           favelement.classList.add("favorited");
  //         }
  //       });
     
  //     }
  //   });
  // }
  // initializeFavoritedProducts();

  function initializeFavoritedProducts() {
    if (getCookieValue('favoritedProducts') == null) {
      return;
    }
    myArray = getCookieValue('favoritedProducts').split(",");
    myArray.forEach((favedProduct, index) => {
      if (favedProduct != "") {
        var favelements = document.querySelectorAll('[data-productid="' + favedProduct + '"]');
        favelements.forEach(favelement => {
          if (favelement != null) {
            favelement.classList.add("favorited");
          }
        });
      }
    });
  }
  initializeFavoritedProducts();
  
  function countProducts() {
    if (getCookieValue('favoritedProducts') == null || getCookieValue('favoritedProducts') == '') {
      return null;
    }
    return getCookieValue('favoritedProducts').split(",").length - 1;
  }
  
  function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", theUrl, false); // false for synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
  }
  
  function generateWishlistId(theUrl) {
    var xhr = new XMLHttpRequest();
    var url = theUrl;
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
        const cookieName = "wishlistId";
        const cookieValue = json.id;
        const daysToExpire = new Date(2147483647 * 1000).toUTCString();
        document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=boandbirdie.com';
        return getCookieValue('wishlistId');
      }
    };
    var data = JSON.stringify({});
    xhr.send(data);
  }
  
  function getWishlistId() {
    if (getCookieValue('wishlistId') !== null && getCookieValue('wishlistId') != '') {
      return getCookieValue('wishlistId');
    }
    const cookieName = "wishlistId";
    const cookieValue = "generating";
    const daysToExpire = new Date(2147483647 * 1000).toUTCString();
    document.cookie = cookieName + '=' + cookieValue + '; expires=' + daysToExpire + ';path=/;domain=boandbirdie.com';
    generateWishlistId('https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlists.php');
    return null;
  }
  
  function addWishlistItem(productid, product_title, product_url, image_url) {
    
    if (getWishlistId() == null || getWishlistId() == "generating") {
      setTimeout(function() {
        addWishlistItem(productid, product_title, product_url, image_url);
      }, 200);
      return;
    }
    
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/add_wishlist_item.php?id=" + getWishlistId();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({
      "productid": parseInt(productid),
      "product_title": product_title,
      "product_url": product_url,
      "image_url": image_url
    });
    xhr.send(data);
  }
  
  function removeWishlistItem(productid) {
    if (getWishlistId() == null) {
      return;
    }
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/remove_wishlist_item.php?id=" + getWishlistId() + "/" + productid;
    xhr.open("DELETE", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({});
    xhr.send(data);
  }

  document.addEventListener('DOMContentLoaded', function() {
      // Wait for 1 second after body is ready
      setTimeout(function() {
        // Check if the body has class teeinblue-enabled
        if(document.body.classList.contains('teeinblue-enabled')) {
            // Select the div with class .shipping_usp
            var shippingUspDiv = document.querySelector('.shipping_usp');
            // Select the target div with ID #teeFormActions
            var targetDiv = document.querySelector('#teeFormActions');

            // If both divs exist, append the .shipping_usp div to the end of #teeFormActions
            if(shippingUspDiv && targetDiv) {
                targetDiv.appendChild(shippingUspDiv);
            }
        }
      }, 1000); // 1000ms = 1 second
  });

  function addMailToWishlist() {
    
    var xhr = new XMLHttpRequest();
    var url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/add_mail.php?id=" + getWishlistId();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 201) {
        var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({
      "mail": document.getElementById('email_wishlist').value
    });
    xhr.send(data);
    document.getElementById('added-to-wishlist-mail').classList.remove("slide-right");
  }
  function continueWithout(e){
    document.getElementById('added-to-wishlist-mail').classList.remove("slide-right");
    e = e || window.event;
    e.preventDefault();
  }
  // page js
  function removeElement(id) {
    var elem = document.getElementById(id);
    return elem.parentNode.removeChild(elem);
  }

  function findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
    return result;
  }


document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('fav-count').innerHTML = countProducts();
    if(!document.getElementById('wa-link')) return
    document.getElementById('wa-link').href = "https://wa.me/?text=Schau%20mal%2C%20das%20ist%20meine%20Wunschliste%20von%20boandbirdie.com%20mit%20meinen%20Lieblingspostern%3A%20" + encodeURIComponent("https://boandbirdie.com/pages/wunschliste?ref=" + getCookieValue('wishlistId'));
    document.getElementById('fb-link').href = "fb-messenger://share/?link=" + encodeURIComponent("https://boandbirdie.com/pages/wunschliste?ref=" + getCookieValue('wishlistId'));

    var url = null;
    if (getCookieValue('wishlistId') !== null && getCookieValue('wishlistId') != '') {
      url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlist.php?id=" + getCookieValue('wishlistId');
    }

    if (findGetParameter("ref") != null) {
      url = "https://monkfish-app-6yhq2.ondigitalocean.app/wishlist/api/wishlist.php?id=" + findGetParameter("ref");

      var elem = document.getElementById('sharewishlist');
      elem.parentNode.removeChild(elem);
    }
    if (url !== null) {
      
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var json = JSON.parse(xhr.responseText);
          
          document.getElementById("wishlist").innerHTML = "";
          json.forEach(element => {
            var template =
              `
                  <product-card class="product-card product_wishlist_set" id="product-##PRODUCTID##">
                    <div class="product-card__figure">
                      <a href="##PRODUCTURL##" class="product-card__media">
                        <img src="##IMAGEURL##" height="" width=""/>
                      
                      </a>
                      <span class="wishlist-tooltip favProduct favorited" data-productid="##PRODUCTID##" data-producttitle="##PRODUCTNAME##" data-producturl="##PRODUCTURL##" data-imageurl="##IMAGEURL##">
                        <i class="i-wishlist i-wishlist--add"></i>
                      </span>
                    
                      <div class="product-card__info empty:hidden">
                        <div class="product-title h6">##PRODUCTNAME##</div>
                      </div>
                    </div>
                  </product-card>`;
            template = template.replace('##PRODUCTURL##', element.product_url);
            template = template.replace('##PRODUCTURL##', element.product_url);
            template = template.replace('##IMAGEURL##', element.image_url);
            template = template.replace('##IMAGEURL##', element.image_url);
            template = template.replace('##PRODUCTNAME##', element.product_title);
            template = template.replace('##PRODUCTNAME##', element.product_title);
            template = template.replace('##PRODUCTID##', element.product_id);
            template = template.replace('##PRODUCTID##', element.product_id);
            document.getElementById("wishlist").innerHTML = document.getElementById("wishlist").innerHTML + template;

          });

          const boxes = document.querySelectorAll('.favProduct');

          if (findGetParameter("ref") == null) {
            boxes.forEach(box => {
              box.addEventListener('click', favProduct);
            });
          } else {
            boxes.forEach(box => {
              box.parentNode.removeChild(box);
            });
          }
        }
        if (xhr.status === 404) {
          document.getElementById("wishlist").innerHTML = '<div style="text-align:center">Deine Wunschliste ist leer.</div>';
          var elem = document.getElementById('sharewishlist');
          elem.parentNode.removeChild(elem);

        }
      };
      var data = JSON.stringify({});
      xhr.send(data);
    }
});

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      
    } catch (err) {
     
    }

    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(e, text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
     
    }, function(err) {
     
    });
    e = e || window.event;
    e.preventDefault();
  }

// .focus() event for Android;
document.addEventListener("DOMContentLoaded", function() {
  const searchControls = document.getElementById("search_header_controls");
  const searchInput = document.getElementById("searchInput");

  if (searchControls && searchInput) {
    searchControls.addEventListener("click", function() {
      setTimeout(() => searchInput.focus(), 500);
      let reviewTimeout = setTimeout(() => {
          ReviweWidget();
      }, 1000);
      
      setTimeout(() => {
          clearTimeout(reviewTimeout);
      }, 5000);
    });

    searchInput.addEventListener("focus", function() {
      // Add any logic you want to execute when searchInput gains focus
    });
  } else {
    if (!searchControls) {
      console.error('Element with id "search_header_controls" not found.');
    }
    if (!searchInput) {
      console.error('Element with id "searchInput" not found.');
    }
  }
});

function ReviweWidget() {
  // Define your ReviweWidget function here
}

window.customilyShopify = window.customilyShopify || {};
window.customilyShopify.optimization = {
  enableBinarySearch: true,
  enableConflictDetection: true,
};

document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.cart-footer.cart-sticky')){
  const cartFooter = document.querySelector('.cart-footer.cart-sticky');
  const height = cartFooter.offsetHeight;
  document.documentElement.style.setProperty('--cart-form-padding', `${height}px`);
  }
});

// append payment icons
setTimeout(function() {
  if (document.body.classList.contains('teeinblue-enabled')) {
    const shippingUsp = document.querySelector('#teeFormActions');
    const paymentIcons = document.querySelector('.payments-product-icons');

    if (shippingUsp && paymentIcons) {
      shippingUsp.insertAdjacentElement('afterend', paymentIcons);
    }
  }
}, 2000);



  